import React, { useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, FormFeedback, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { useModalCrudState } from '../../../../_helper/hooks/useModalCrudState';

const WorkFileTypeDataModal = ({ apiEndpoint, isOpen, toggle, mode, selectedWorkFileType, refreshData }) => {
    const initialWorkFileTypeData = {
        id: '',
        title: '',
    };

    const validationSchema = useMemo(() => ({
        title: {
            required: true,
            message: 'İş Dosyası tipi başlığı zorunludur.',
            minLength: 2,
            minLengthMessage: 'Başlık en az 2 karakter olmalıdır.',
        },
    }), []);

    const {
        formData: workFileTypeData,
        errors,
        handleCancel,
        handleInputChange,
        handleSubmit,
        isSubmitting,
    } = useModalCrudState({
        isOpen,
        mode,
        selectedItem: selectedWorkFileType,
        initialData: initialWorkFileTypeData,
        toggle,
        normalizeInput: true,
        validationSchema,
        submitConfig: {
            apiEndpoint,
            selectedItem: mode === 'modify' ? { id: selectedWorkFileType?.id } : null,
            refreshData,
            componentName: 'İş Dosyası Tipi',
            buildPayload: (data) => ({
                title: data.title,
                ...(mode === 'modify' && selectedWorkFileType?.id && { id: selectedWorkFileType.id }),
            }),
        },
    });

    const getModalTitle = () => {
        return mode === 'add' ? 'İş Dosyası Tipi Ekle' : 'İş Dosyası Tipi Düzenle';
    };

    const getButtonLabel = () => {
        return mode === 'add' ? 'Ekle' : 'Güncelle';
    };

    return (
        <Modal isOpen={isOpen} toggle={handleCancel} backdrop="static">
            <ModalHeader toggle={handleCancel}>{getModalTitle()}</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="title">Tür Adı <span className="text-danger">*</span></Label>
                        <Input
                            type="text"
                            id="title"
                            name="title"
                            value={workFileTypeData.title || ''}
                            onChange={handleInputChange}
                            placeholder="İş Dosyası Türü Adı"
                            invalid={!!errors.title}
                        />
                        <FormFeedback>{errors.title}</FormFeedback>
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="outline-success" className="rounded-pill" onClick={handleSubmit} disabled={isSubmitting}>
                    {isSubmitting ? 'Kaydediliyor...' : getButtonLabel()}
                </Button>
                <Button color="outline-danger" onClick={handleCancel} className="ms-2 rounded-pill">
                    İptal
                </Button>
            </ModalFooter>
        </Modal>
    );
};

WorkFileTypeDataModal.propTypes = {
    apiEndpoint: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    mode: PropTypes.oneOf(['add', 'modify']).isRequired,
    selectedWorkFileType: PropTypes.object,
    refreshData: PropTypes.func.isRequired,
};

export default WorkFileTypeDataModal;
